import { render } from "./KoruPdf.vue?vue&type=template&id=47ccb8ce&ts=true"
import script from "./KoruPdf.vue?vue&type=script&lang=ts"
export * from "./KoruPdf.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__